import React from 'react';
import TableHeader from '../TableHeader';
import moment from 'moment';

const YayGoldTransactionsList = ({
  yayGoldTransactions, total
}) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Yay Gold Transactions list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} transactions</p>
        </div>
      </div>

      <div className='Table Table--yay-gold-transaction-list'>
        {(() => {
          let columnHeaders = [
            {
              label: 'Type'
            },
            {
              label: 'Wallet ID',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Amount',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Referred Wallet ID'
            },
            {
              label: 'Calculated Date',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Timestamp',
              sortKey: 'timestamp',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Vault',
              className: 'Table__col--ta-c'
            },
            {
              label: 'Created at',
              sortKey: 'created_at',
              className: 'Table__col--ta-c'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {yayGoldTransactions.map((yayGoldTransaction) => (
          <div className='Table__row' key={yayGoldTransaction.id} data-x={yayGoldTransaction}>
            <div className='Table__col'>
              {yayGoldTransaction.sourceType}
            </div>
            <div className='Table__col Table__col--ta-c'>
             {
                <a
                  className='Table__a'
                  href={`/${gon.currentProvider}/wallet?id=${yayGoldTransaction.walletId}`}>
                    {yayGoldTransaction.walletId}
                </a>
              }
            </div>
            <div className='Table__col Table__col--ta-c'>
              {yayGoldTransaction.amount}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {
                yayGoldTransaction.referredWalletId &&
                <a
                  className='Table__a'
                  href={`/${gon.currentProvider}/wallet?id=${yayGoldTransaction.referredWalletId}`}>
                    {yayGoldTransaction.walletId}
                </a>
              }
            </div>
            <div className='Table__col Table__col--ta-c'>
              {yayGoldTransaction.calculatedDate}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {yayGoldTransaction.timestamp}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {yayGoldTransaction.vault}
            </div>
            <div className='Table__col Table__col--ta-c'>
              {moment(yayGoldTransaction.createdAt).format('YYYY-MM-DD HH:mm')}
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default YayGoldTransactionsList;
